import { cn } from "~/lib/utils";
import { LandingCenterAnimationLeft, LandingCenterAnimationRight } from "./animation";
import LandingContent from "./content";
import arrowRightWhiteImg from "~/assets/landing-page/arrow-right-white.svg";
import pointImg from "~/assets/landing-page/point.svg";
import { useEffect, useState } from "react";
import Counter from "~/components/ui/counter";

export default function LandingCenter({ onGetApp, onGoToShop }: { onGetApp: () => void; onGoToShop: () => void }) {
  return (
    <LandingContent className="flex flex-col items-center justify-center">
      <p className="justify-center p-[24px] text-center text-4xl leading-10 font-semibold text-wrap text-neutral-900 md:text-nowrap">
        Play. Shop. Save. All in Blidz.
      </p>
      <div className="flex flex-col items-center justify-center gap-[32px] p-[24px] lg:flex-row">
        <div
          className={cn(
            "relative",
            "flex flex-col items-center justify-center gap-[24px] rounded-[32px]",
            "h-full max-h-[386px] w-full max-w-[342px] md:max-h-[509px] md:max-w-[497px] xl:max-h-[541px] xl:max-w-[512px]"
          )}
        >
          <div className="absolute top-0 z-10 flex flex-col items-center justify-center">
            <p className="justify-start text-center text-base leading-loose font-semibold text-black md:text-2xl lg:text-3xl">
              Make Money
            </p>
            <p className="justify-start text-center text-base leading-normal font-medium text-neutral-600">
              Play games and watch videos to earn Points.
            </p>
          </div>
          <div className="relative">
            <LandingCenterAnimationLeft className="overflow-hidden rounded-[32px]" />
            <div
              className={cn(
                "rounded-r-[32px]",
                "absolute inset-y-0 right-0 z-10 h-full",
                "w-0 lg:w-[66px] xl:w-[83px]",
                "bg-gradient-to-r from-[#FDF85300] to-[#FFE12885]"
              )}
            />
          </div>
          <button
            onClick={onGetApp}
            className="inline-flex h-12 cursor-pointer items-center justify-center gap-1 rounded-2xl bg-gradient-to-b from-zinc-800 to-black px-5 py-2 outline-1 outline-offset-[-1px] outline-white/5 hover:shadow-[0px_0px_12px_0px_rgba(0,0,0,0.25)]"
          >
            <div className="justify-start text-base leading-normal font-bold text-white">Get $100 Cash</div>
            <img src={arrowRightWhiteImg} alt="arrow-right" className="h-4 w-4" />
          </button>
        </div>
        <div className="hidden xl:block">
          <MiddleCard />
        </div>
        <div
          className={cn(
            "relative",
            "flex flex-col items-center justify-center gap-[24px] rounded-[32px]",
            "h-full max-h-[386px] w-full max-w-[342px] md:max-h-[509px] md:max-w-[497px] xl:max-h-[541px] xl:max-w-[512px]"
          )}
        >
          <div className="absolute top-0 z-10 flex flex-col items-center justify-center">
            <p className="justify-start text-center text-base leading-loose font-semibold text-black md:text-2xl lg:text-3xl">
              Save Money
            </p>
            <p className="justify-start text-center text-base leading-normal font-medium text-neutral-600">
              Spend Points on free deals and special discounts.
            </p>
          </div>

          <div className="relative">
            <LandingCenterAnimationRight className="overflow-hidden rounded-[32px]" />
            <div
              className={cn(
                "rounded-l-[32px]",
                "absolute inset-y-0 left-0 z-10 h-full",
                "w-0 lg:w-[66px] xl:w-[83px]",
                "bg-gradient-to-r from-[#FFE12885] to-[#FDF85300]"
              )}
            />
          </div>
          <button
            onClick={onGoToShop}
            className="inline-flex h-12 cursor-pointer items-center justify-center gap-1 rounded-2xl bg-gradient-to-b from-zinc-800 to-black px-5 py-2 outline-1 outline-offset-[-1px] outline-white/5 hover:shadow-[0px_0px_12px_0px_rgba(0,0,0,0.25)]"
          >
            <div className="justify-start text-base leading-normal font-bold text-white">Go Shopping</div>
            <img src={arrowRightWhiteImg} alt="arrow-right" className="h-4 w-4" />
          </button>
        </div>
      </div>
    </LandingContent>
  );
}

function MiddleCard() {
  const startPoints = 1000;
  const endPoints = 3804;

  const [points, setPoints] = useState(startPoints);

  useEffect(() => {
    const interval = setInterval(() => {
      const addPoints = Math.floor(Math.random() * 100 + 100);
      setPoints(prev => {
        if (prev >= endPoints) {
          return startPoints;
        }
        const newPoints = prev + addPoints;
        if (newPoints > endPoints) {
          return endPoints;
        }
        return newPoints;
      });
    }, 1500);

    return () => clearInterval(interval);
  }, []);

  return (
    <div
      className={cn(
        "overflow-hidden rounded-[32px]",
        "shadow-[0px_0px_50px_0px_#EDCB2B7A]",
        "border border-[#0000000D]",
        "h-[257px] w-[304px]",
        "flex flex-col items-center justify-between p-[32px]"
      )}
      style={{
        background: `
        radial-gradient(83.5% 83.5% at 11.25% 10.5%, #FFF7A9 0%, #FFF47E 46.15%, rgba(255, 245, 0, 0) 100%),
        radial-gradient(89% 89% at 90.75% 32%, #FFD000 0%, #FFFEF7 100%),
        linear-gradient(0deg, #FFFFFF, #FFFFFF)
        `,
      }}
    >
      <div className="flex flex-col items-center justify-center gap-1 self-stretch">
        <p className="justify-start text-center text-3xl leading-7 font-semibold text-black">Points</p>
        <p className="justify-start self-stretch text-center text-base leading-normal font-medium text-neutral-600">
          Redeem Points for real-money payout or free deals.
        </p>
      </div>
      <div className="rounded-3xl bg-white p-6 shadow-[0px_12px_20px_0px_rgba(0,0,0,0.05)]">
        <div className="flex items-center justify-center gap-2">
          <div className="flex items-center justify-start gap-1">
            <img src={pointImg} alt="point" className="h-6 w-6" />
            <div className="justify-start overflow-hidden text-center text-4xl leading-10 font-bold text-black">
              <div className="relative">
                <span className="invisible">9999</span>
                <span className="absolute inset-0 flex items-center justify-center">
                  <Counter
                    value={points}
                    places={[1000, 100, 10, 1]}
                    fontSize={32}
                    padding={0}
                    gap={0}
                    textColor="black"
                    fontWeight={700}
                  />
                </span>
              </div>
            </div>
          </div>
          <div className="justify-start text-base leading-normal font-medium text-neutral-600">
            <div className="relative">
              <span className="invisible">$9.9</span>
              <span className="absolute inset-0">${Number((points / 1000).toFixed(1))}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
